import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import HeaderMobile from 'Component/header-mobile';
import ListContent from 'View/productivity-host/section/list-content';
import Tab from 'View/productivity-host/section/tab';
import BriefLiveProvider from 'View/productivity-host/state';

import styles from './styles.module.css';

const BriefLive = () => {
  const { t } = useTranslation('host-brief');
  const navigate = useNavigate();

  return (
    <Box className={styles['brief-live__container']}>
      <HeaderMobile type="header-back" title={t('brief_live')} onClick={() => navigate('/host')} />
      <Tab />
      <Box className={styles['brief-live__content']}>
        <ListContent />
      </Box>
    </Box>
  );
};

const BriefLiveContainer = () => <BriefLiveProvider children={<BriefLive />} />;

export default BriefLiveContainer;
